import {
  SET_SKY_THREE_TASK_LIST,
  SET_SKY_THREE_TASK_LIST_PAGE,
  SET_SKY_THREE_TASK_LIST_PAGE_TOTAL,
  SET_SKY_THREE_TASK_LIST_QUERY,
  SET_SKY_THREE_TASK_STATE_TYPE,
  SET_SKY_THREE_LIST_PAGE_SIZE,
  SET_SKY_THREE_SORT,
  SET_SKY_THREE_RUNNING_STATUS,
  SET_SKY_THREE_END_STATUS,
  SET_SKY_THREE_SEARCHING,
  CHANGE_SKY_THREE_QUERY,
  RESET_SKY_THREE_TASK_LIST_QUERY,
} from './mutation-types'
import api from '@/api'
import {objectTrim} from '@/utils'
import {TaskType} from '@/constants'

const initQuery = () => ({
  pageNum: 1,
  pageSize: 50,
  taskTypes: [TaskType.Triangulation],
  areaIds: [],          // [int option] 区域
  // userId: 0,          // [str option] 用户id
  userName: '',        // [str option] 用户名
  userId: '',          // [str option] 用户id
  taskId: '',          // [int option] 平台作业id
  taskStatus: '',          // [int option] 状态
  sky3IdSort: '',   // [int option] 分析任务id排序字段，0：降序，1：升序
  submitTimeFlag: '',  // [int option] 提交时间排序字段，0：降序，1：升序
  startTimeFlag: '',   // [int option] 开始时间排序字段，0：降序，1：升序
  endTimeFlag: '',     // [int option] 结束时间排序字段，0：降序，1：升序
  statusSort: '',      // [int option] 状态排序字段，0：降序，1：升序
  keywords: '',
})

const sky3Running = () => ({
  list: [],
  listPageTotal: 0,
  query: initQuery(),
  sort: {
    submitTimeFlag: 0,
  },
})

const sky3End = () => ({
  list: [],
  listPageTotal: 0,
  query: initQuery(),
  sort: {
    endTimeFlag: 0,
  },
})

const state = {
  sky3Running: sky3Running(),
  sky3End: sky3End(),
  initQuery: initQuery(),
  groups: [],
  stateType: {},
  initPageSize: 50,
  sky3RunningStatus: [],
  sky3EndStatus: [],
  searching: false,
}

const mutations = {
  [SET_SKY_THREE_TASK_LIST] (state, payload) {
    state.stateType.list = payload
  },
  [SET_SKY_THREE_TASK_LIST_PAGE] (state, payload) {
    state.stateType.query.pageNum = payload
  },
  [SET_SKY_THREE_TASK_LIST_PAGE_TOTAL] (state, payload) {
    state.stateType.listPageTotal = payload
  },
  [SET_SKY_THREE_LIST_PAGE_SIZE] (state, payload) {
    state.stateType.query.pageSize = payload
  },
  [SET_SKY_THREE_TASK_LIST_QUERY] (state, payload) {
    state.stateType.query = {
      ...state.stateType.query,
      ...payload,
    }
  },
  [RESET_SKY_THREE_TASK_LIST_QUERY] (state, payload) {
    state.stateType.query = payload
  },
  [SET_SKY_THREE_TASK_STATE_TYPE] (state, payload) {
    state.stateType = payload
  },
  [SET_SKY_THREE_SORT] (state, payload) {
    state.stateType.sort = payload
  },
  [SET_SKY_THREE_RUNNING_STATUS] (state, payload) {
    state.sky3RunningStatus = payload
  },
  [SET_SKY_THREE_END_STATUS] (state, payload) {
    state.sky3EndStatus = payload
  },
  [SET_SKY_THREE_SEARCHING] (state, payload) {
    state.searching = payload
  },
  [CHANGE_SKY_THREE_QUERY] (state, payload) {
    let taskFlag = payload.taskFlag === 0 ? 'sky3Running' : 'sky3End'
    Reflect.deleteProperty(payload, 'taskFlag')
    state[taskFlag].query = {
      ...state[taskFlag].query,
      ...payload,
    }
  },
}

const actions = {
  // 获取state类型
  getStateType ({commit, state}, taskFlag) {
    switch (taskFlag) {
      case 0:
        commit(SET_SKY_THREE_TASK_STATE_TYPE, state.sky3Running)
        break
      case 1:
        commit(SET_SKY_THREE_TASK_STATE_TYPE, state.sky3End)
        break
    }
  },
  // 获取运行/完成的分析作业列表
  async getBuildEndTaskList ({commit, state, dispatch}, payload) {
    try {
      await dispatch('getStateType', payload.taskFlag)
      !payload.taskStatus && payload.taskStatus !== 0 && Reflect.deleteProperty(payload, 'taskStatus')
      let param = objectTrim({
        ...state.stateType.query,
        ...state.stateType.sort,
        ...payload,
        taskTypes: [TaskType.Triangulation],
      })
      // Reflect.deleteProperty(param, 'userIds')
      commit(SET_SKY_THREE_SEARCHING, true)
      const {data: {items, total}} = await api.dayanTaskApi.getBuildEndTaskList(param)
      commit(SET_SKY_THREE_SEARCHING, false)
      items.map((itm) => {
        itm.taskFlag = payload.taskFlag
      })
      commit(SET_SKY_THREE_TASK_LIST_PAGE_TOTAL, total)
      commit(SET_SKY_THREE_TASK_LIST, items)
    } catch (error) {
      console.log(error)
      commit(SET_SKY_THREE_SEARCHING, false)
      commit(SET_SKY_THREE_TASK_LIST_PAGE_TOTAL, 0)
      commit(SET_SKY_THREE_TASK_LIST, [])
    }
  },
  // 初始化列表
  async initSky3TaskList ({commit, dispatch, state}, taskFlag) {
    let query = {
      userName: '',
      taskId: '',
      taskStatus: '',
      areaId: '',
    }
    await dispatch('filterQuery', {query: query, taskFlag: taskFlag})
    commit(SET_SKY_THREE_LIST_PAGE_SIZE, state.initPageSize)
  },
  // 分析作业列表翻页
  async changeSky3TaskListPage ({commit, state, dispatch}, payload) {
    commit(SET_SKY_THREE_TASK_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('getBuildEndTaskList', payload)
    return Promise.resolve(true)
  },
  // 改变每页显示条数
  async changePageSize ({commit, dispatch}, payload) {
    dispatch('getStateType', payload.taskFlag)
    commit(SET_SKY_THREE_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeSky3TaskListPage', {currentPage: 1, taskFlag: payload.taskFlag, noXHR: true, taskStatus: payload.taskStatus})
    return Promise.resolve(true)
  },
  // 分析作业列表筛选
  async changeSky3TaskMessageQuery ({commit, dispatch}, taskFlag) {
    await dispatch('changeSky3TaskListPage', {currentPage: 1, taskFlag: taskFlag})
  },
  // 列表表头筛选
  async filterQuery ({commit, dispatch}, payload) {
    await dispatch('getStateType', payload.taskFlag)
    // commit(SET_SKY_THREE_TASK_LIST_QUERY, payload.query) // 取消重置 query, 日期8-19-gt, 需求, 不清楚会产生什么影响
    await dispatch('changeSky3TaskListPage', {currentPage: 1, taskFlag: payload.taskFlag, taskStatus: payload.query.taskStatus})
  },
  // 筛选参数
  async setSky3Query ({commit, dispatch, state}, payload) {
    await dispatch('getStateType', payload.taskFlag)
    commit(SET_SKY_THREE_TASK_LIST_QUERY, payload.query)
  },
  // 重置筛选参数
  resetSky3Query ({commit, state}) {
    commit(RESET_SKY_THREE_TASK_LIST_QUERY, state.initQuery)
  },
  // 排序
  changeSort ({commit, dispatch}, payload) {
    commit(SET_SKY_THREE_SORT, payload.sort)
    dispatch('changeSky3TaskListPage', {currentPage: 1, taskFlag: payload.taskFlag})
  },
  resetSort ({dispatch}, {taskFlag}) {
    dispatch('changeSort', {taskFlag})
  },
  changeSky3Query ({commit}, payload) {
    commit(CHANGE_SKY_THREE_QUERY, payload)
  },
  // 清空黑名单
  async cleanBlackList ({commit}, payload) {
    const data = await api.dayanTaskApi.cleanBlackList(payload)
    return data
  },
  // 停止状态
  // eslint-disable-next-line
  async sky3StopTask ({}, payload) {
    const data = await api.dayanTaskApi.stopTask({taskIds: payload})
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
